import { ReactElement } from 'react';

import { css } from '@emotion/react';

import Icon from '@components/common/Icon/Icon';

import {
  emphasizeText,
  gridItem,
  infoButton,
} from '../fraudSearchResult.style';
import { LocalResultDetailTypeProps } from './ResultDetailCS';

export default function ResultDetailMonitoring({
  props: { handleToggle, infoText, reportPath },
}: LocalResultDetailTypeProps): ReactElement {
  return (
    <div css={[gridItem, resultMonitoring]}>
      <button
        type="button"
        aria-label="info"
        css={infoButton}
        onClick={() => handleToggle(infoText)}
      >
        <Icon icon="info" />
      </button>
      <p className="title">중고나라 모니터링 {'\n'}제재 건 수</p>
      <p className="content">
        <span css={emphasizeText(true)}>
          {reportPath!.manual_app + reportPath!.manual_cafe || '0'}
        </span>{' '}
        건
      </p>
    </div>
  );
}

const resultMonitoring = css`
  grid-column: 2/3;
`;
